import FormBoAntrag from "../step-antrag/FormBo";
import FormBoIhrTier from "../step-ihr-tier/FormBo";
import FormBoAngebot from "../step-angebot/FormBo";
import FormBoEingereicht from "../step-eingereicht/FormBo";
import FormulardatenViewDto from "../../../../consumer/form/dto/FormulardatenViewDto";

export default class WizardFormBo {
    activeStep = 0;
    antrag = new FormBoAntrag();
    ihrTier = new FormBoIhrTier();
    angebot = new FormBoAngebot();
    eingereicht = new FormBoEingereicht();

    static exportFormulardaten(bo: WizardFormBo) {
        const dto = new FormulardatenViewDto();

        dto.antrag = FormBoAntrag.exportFormulardaten(bo.antrag);
        dto.ihrTier = FormBoIhrTier.exportFormulardaten(bo.ihrTier);
        dto.angebot = FormBoAngebot.exportFormulardaten(bo.angebot);
        return dto;
    }

    static importFormulardaten(formDto?: FormulardatenViewDto) {
        const bo = new WizardFormBo();

        if (formDto === undefined) {
            return bo;
        }
        bo.antrag = FormBoAntrag.importFormulardaten(formDto.antrag);
        return bo;
    }

}

